<template>
  <div class="logout-container">
    <div class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <h4 class="mt-3">Logging out...</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logout',
  mounted() {
    // Clear all session data from localStorage
    const userType = localStorage.getItem("userType");

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userType");
    localStorage.removeItem("merchantUser");
    localStorage.removeItem("merchantUuid");
    localStorage.removeItem("merchantName");

    // Redirect to login page after a short delay
    setTimeout(() => {
      if(userType == "merchant"){
        this.$router.push("/merchant/login");
      }else{
        this.$router.push("/login");
      }
    }, 1000);
  }
};
</script>

<style scoped>
.logout-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #2b2e4c;
}

.text-center {
  color: #fff;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style> 